import React from "react"
export function TickFill(props) {
  return (
    <svg viewBox="0 0 20 20" {...props}>
      <path
        d="M10 2c4.411 0 8 3.589 8 8s-3.589 8-8 8-8-3.589-8-8 3.589-8 8-8zm3.165 5.107l-4.803 4.139-1.929-2.214-1.13.986 2.42 2.776.071.072a.75.75 0 00.894.07l.09-.067 5.366-4.626-.98-1.136z"
        fill="currentColor"
        id="prefix__tick---fill"
        stroke="none"
        strokeWidth={1}
        fillRule="evenodd"
      />
    </svg>
  )
}
